// extracted by mini-css-extract-plugin
module.exports = {"page":"_13432","my_order":"_1761","hint":"_303","title":"_16909","status":"_1392","content":"_7048","cover":"_14956","number":"_12488","date":"_13773","price":"_13701"};